import { computed, observable, transaction, makeObservable } from "mobx"
import { BaseStore } from "stores/base.store"
import { RootStore } from "stores/root.store"
import { getRedeemLimits, IRedeemLimits, updateRedeemLimits } from "../api/redeem-limits.call"

export class RedeemLimitsStore extends BaseStore {
  @observable
  private _data: IRedeemLimits

  constructor(rootStore: RootStore) {
    super(rootStore)
    makeObservable(this)
  }

  async getData(): Promise<IRedeemLimits> {
    this.resetFuncAfterSuccess()
    const res = await this.defaultFunction(getRedeemLimits)
    if (res) {
      transaction(() => {
        this._data = res
      })
    }

    return res
  }

  async update(input: IRedeemLimits) {
    await this.defaultFunction(updateRedeemLimits, input)
  }

  @computed
  get data(): IRedeemLimits {
    return this._data
  }
}
